export default __webpack_public_path__ + "static/media/spark_31.7adcb6e0.png";